import { Component, OnInit } from '@angular/core';
import { FuseConfigService } from '../../../../../core/services/config.service';
import { fuseAnimations } from '../../../../../core/animations';

/**Local file */
import { spekwo, register } from '../../utils/index';

@Component({
    selector: 'registration-main',
    templateUrl: './registeration.component.html',
    styleUrls: ['./registeration.component.scss'],
    animations: fuseAnimations
})
export class RegisterationComponent implements OnInit {

    spekwoValues = spekwo;
    registerValues = register;

    constructor(
        private fuseConfig: FuseConfigService,
    ) {
        this.fuseConfig.setSettings({
            layout: {
                navigation: 'none',
                toolbar: 'none',
                footer: 'none'
            }
        });
    }

    ngOnInit() {
    }
}




// WEBPACK FOOTER //
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/main/content/apps/authentication/registration/registeration.component.ts